import { gql } from 'apollo-angular';
import { TypedDocumentNode } from '@apollo/client';
import {
  QuestionContainer,
  HierarchicalRootQuestion,
  HierarchicalRootQuestionResponse
} from '@ui/shared/model';
import {
  questionContainerFields,
  rootQuestionContainerFields
} from '@ui/legacy-lib';

interface CustomQuestionsByPropertyQueryResponse {
  customQuestionsByProperty: QuestionContainer;
}

interface QuestionsByCustomerQueryResponse {
  questionsByCustomer: QuestionContainer;
}

interface QuestionsAndAnswersByCustomerQueryResponse {
  questionsAndAnswersByCustomer: QuestionContainer;
}

interface HierarchicalRootQuestionResponseMutationResponse {
  hierarchicalRootQuestionResponse: HierarchicalRootQuestion[];
}

export const saveCustomQuestionResponsesMutation = gql`
  mutation saveCustomQuestionResponses($input: [CustomQuestionResponseInput]) {
    saveCustomQuestionResponses(input: $input) {
      status
      statusText
    }
  }
`;

export const hierarchicalRootQuestionResponseMutation: TypedDocumentNode<
  HierarchicalRootQuestionResponseMutationResponse,
  { input: HierarchicalRootQuestionResponse[] }
> = gql`
  mutation hierarchicalRootQuestionResponse($input: [HierarchicalRootQuestionResponseInput]) {
    hierarchicalRootQuestionResponse(input: $input) {
      ${rootQuestionContainerFields}
    }
  }
`;

export const customQuestionsByPropertyQuery: TypedDocumentNode<
  CustomQuestionsByPropertyQueryResponse,
  { id: string }
> = gql`
  query customQuestionsByProperty($id: ID!) {
    customQuestionsByProperty(id: $id) {
      ${questionContainerFields}
    }
  }
`;

export const questionsByCustomerQuery: TypedDocumentNode<
  QuestionsByCustomerQueryResponse,
  { id: string }
> = gql`
  query questionsByCustomer($id: ID!) {
    questionsByCustomer(id: $id) {
      ${questionContainerFields}
    }
  }
`;

export const questionsAndAnswersByCustomerQuery: TypedDocumentNode<
  QuestionsAndAnswersByCustomerQueryResponse,
  { id: string }
> = gql`
  query questionsAndAnswersByCustomer($id: ID!) {
    questionsAndAnswersByCustomer(id: $id) {
      ${questionContainerFields}
    }
  }
`;
